module.exports = __webpack_public_path__ + "img/resources-375.7371bcfb.jpg";